import httpRequest from '../../common/lib/http-request';

// *******************
// SIGNATURE SERVICES
// *******************

function getSignatureAppAccessUrl(ballotRef) {
    return httpRequest({
        url: '/Signature/url/' + ballotRef,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

const SignatureService = { getSignatureAppAccessUrl }

export default SignatureService;